import { useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Flex } from '@radix-ui/themes';
import clsx from 'clsx';
import MobileNav from '../MobileNav';
import Sidebar from '../Sidebar';
import IdleTimeoutModal from '../../common/IdleTimeoutModal';
import { useIdleTimeout } from '../../../hooks/useIdleTimeout';
import styles from './index.module.css';

const ROUTES_WITH_HERO_IMAGE = new Set([
  '/',
]);

function DashboardLayout() {
  const [collapsed, setCollapsed] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const { pathname } = useLocation();
  const { warningOpen, continueSession, logOut } = useIdleTimeout();

  const hasHeroImage = ROUTES_WITH_HERO_IMAGE.has(pathname);

  return (
    <div className={clsx(styles.shell, hasHeroImage && styles.shellWithHero)}>
      {warningOpen && <IdleTimeoutModal onContinue={continueSession} onLogOut={logOut} />}

      <MobileNav onOpen={() => setMobileOpen(true)} />

      {mobileOpen && (
        <div
          aria-label="Close navigation"
          className={styles.backdrop}
          onClick={() => setMobileOpen(false)}
          onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { setMobileOpen(false); } }}
          role="button"
          tabIndex={0}
        />
      )}

      <Flex>
        <Sidebar
          collapsed={collapsed}
          onToggle={() => setCollapsed((c) => !c)}
          mobileOpen={mobileOpen}
          onCloseMobile={() => setMobileOpen(false)}
        />

        <Flex asChild direction="column" flexGrow="1">
          <main className={clsx(styles.main, collapsed ? styles.mainCollapsed : styles.mainExpanded)}>
            <Flex className={styles.content} direction="column" flexGrow="1" width="100%">
              <Outlet />
            </Flex>
          </main>
        </Flex>
      </Flex>
    </div>
  );
}

export default DashboardLayout;
